import { push } from "connected-react-router";

import { getMessagesList } from '../../request';
import { checkAndRenewTokens, checkTokenError } from "./auth";
import { clearMessageForm } from "./editMessage";
import { showErrorMessage, hideErrorMessage } from "./ui";

//Загрузка списка сообщений
export const MESSAGES_LOADING_START = "Messages list loading start";
export const MESSAGES_LOADING_SUCCESS = "Messages list loading success";
export const MESSAGES_LOADING_FAILED = "Failure during messages list load";

//Фильтры
export const SWITCH_MESSAGES_FILTER = "Switch messages filter";

//Пагинация
export const CHANGE_MESSAGES_PAGE = "Change messages page";
export const CHANGE_MESSAGES_LIMIT = "Change messages limit";

const startLoading = () => ({
  type: MESSAGES_LOADING_START
});

const loadSuccess = messages => ({
  type: MESSAGES_LOADING_SUCCESS,
  payload: {
    messages: messages || []
  }
});

const loadFailure = () => ({
  type: MESSAGES_LOADING_FAILED,
});


//Загрузка списка сообщений
export const getMessagesListAsync = payload => {
  return async (dispatch) => {
    dispatch(startLoading());
    dispatch(hideErrorMessage());
    await dispatch(checkAndRenewTokens());
    let messages;
    try {
      const accessToken = localStorage.getItem("accessToken");
      messages = await getMessagesList(accessToken, payload);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при загрузке списка сообщений!"));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(messages));
  };
};

export const goToMessageCreation = () => {
  return async (dispatch) => {
    dispatch(clearMessageForm());
    dispatch(push('/create-message'));
  };
};

//Пагинация на странице списка сообщений
export const changeMessagesPage = activePage => ({
  type: CHANGE_MESSAGES_PAGE,
  payload: { activePage }
});

//Отображение элементов на странице списка сообщений
export const changeMessagesLimit = activeLimit => ({
  type: CHANGE_MESSAGES_LIMIT,
  payload: { activeLimit }
});

//Фильтры
export const switchMessagesFilter = filter => ({
  type: SWITCH_MESSAGES_FILTER,
  payload: { filter }
});